export default "__VITE_ASSET__f7bf102e__"